export default "__VITE_ASSET__CPLaq4Pr__"